import { FlexCrate, Grid } from '@perch-labs/shrike';
import styled from 'styled-components';

export const SubNav = styled.nav`
  border-bottom: 1px solid ${props => props.theme.colors.background.tertiary};
  height: 64px;
  margin-top: 8px;
`;

export const BackgroundDiv = styled.div`
  background: ${props => props.theme.colors.background.secondary};
`;

export const Content = styled(FlexCrate).attrs({
  backgroundColor: 'primary',
  flex: '1 1 auto',
  flexDirection: 'column',
})``;

export const StyledGrid = styled(Grid)<StyleProps>`
  ${props =>
    props.mobileFullWidth &&
    `
    @media (max-width: ${props.theme.breakpoints.tabletPortrait}px) {
      > div {
        padding-left: 0;
        padding-right: 0;
      }
    }`}
`;
